<template>
  <ModalForm
    v-model="formData"
    class="modal--md modal__certificate-upsert"
    :title="!certificate ? 'Добавить' : 'Редактировать'"
    text-btn-confirm="Сохранить"
    @request="onRequest"
    @reject="onReject"
  >

    <div class="section--gray column gap-s mb-20">
      <VInput
        v-model="formData.name"
        label="Материал"
        required
      >
        <Validation for="required"/>
      </VInput>

      <!-- Список d проволоки с возможностью добавления/удаления -->
      <div
        v-for="(d_wire, index) in formData.d_wires"
        :key="d_wire.id"
        class="d-flex gap-s between ai-fe"
      >
        <VInput
          v-model="d_wire.value"
          label="d пров.:"
          :pattern="/^[0-9]\d*[.,]?(\d{0,3}?)$/"
          required
        >
          <Validation for="required"/>
          <Validation for="pattern">Только цифры с точностью до тысячных</Validation>
        </VInput>
        <div class="d-flex gap-s">
          <VButton
            icon="remove"
            size="md"
            :disabled="formData.d_wires.length === 1"
            @click.native="removeDWire(index)"
          />
          <VButton
            v-if="index === formData.d_wires.length - 1"
            icon="create"
            size="md"
            color="primary-sm"
            @click.native="addDWire"
          />
        </div>
      </div>
    </div>
  </ModalForm>
</template>

<script>
import ModalForm from '@/components/ui/Modal/ModalForm.vue'
import VInput from '@/components/Form/Vinput/VInput'
import VButton from '@/components/simple/button/VButton'
import { mapActions } from 'vuex'
import Validation from '@/components/Form/Validation.vue'
import { comma2Dot } from '@/utils/string'

export default {
  name: 'ModalCertificateUpsert',
  components: { Validation, ModalForm, VButton, VInput },
  props: {
    /**
     * Сертификат для редактирования (если null — создаём новый)
     */
    certificate: {
      type: Object,
      default: () => null
    }
  },
  data () {
    const dWires = this.certificate?.d_wires?.length
      ? this.certificate.d_wires.map(item => ({
          id: item.id || null,
          value: item.d_wire || ''
        }))
      : [{ id: null, value: '' }]

    return {
      formData: {
        name: this.certificate?.name ?? null,
        d_wires: dWires
      }
    }
  },

  methods: {
    ...mapActions('warehouse/certificates', ['addCertificate', 'updateCertificate']),

    /**
     * Добавить d проволоки
     */
    addDWire () {
      this.formData.d_wires.push({
        id: null,
        value: ''
      })
    },

    /**
     * Удалить d проволоки по индексу
     * @param {number} index
     */
    removeDWire (index) {
      if (this.formData.d_wires.length > 1) {
        this.formData.d_wires.splice(index, 1)
      }
    },

    /**
     * Обработка отправки формы
     * @param {Object} data
     */
    async onRequest (data) {
      try {
        this.$store.commit('SET_IS_SENDING_REQUEST_MODAL')

        const params = {
          name: data.name,
          d_wires: data.d_wires.map(item => ({
            id: item.id,
            d_wire: comma2Dot(item.value, 3).toString()
          }))
        }

        if (this.certificate) {
          params.old_name = this.certificate.name
          await this.updateCertificate(params)
        } else {
          await this.addCertificate(params)
        }

        this.$emit('loadList')
        this.onReject()
      } finally {
        this.$store.commit('SET_IS_SENDING_REQUEST_MODAL', false)
      }
    },

    /**
     * Закрытие модалки
     */
    onReject () {
      this.$emit('reject')
    }
  }
}
</script>
